module.exports = __webpack_public_path__ + "img/btn-claim-name.27fa84e1.png";